import { AppState } from 'src/AppState/AppState';
import { action, computed, makeAutoObservable } from 'mobx';
import { toNumber } from 'lodash';

export class EventsState {
    constructor(private readonly appState: AppState) {
        if (this.eventFromRoute !== null) {
            this.appState.sportsbookState.eventPageState.addToRecentlyViewed(this.eventFromRoute);
        }
        makeAutoObservable(this);
    }

    @computed get eventFromRoute(): number | null {
        const fromUrl = this.appState.routerBackoffice.getValueString('events');
        return fromUrl === null ? null : toNumber(fromUrl);
    }

    @computed get isEventOpened(): boolean {
        return this.eventFromRoute !== null;
    }

    @action onCloseHandler = (key: string): void => {
        this.appState.reduxAction.onCloseEventRequest(Number(key));
        this.appState.sportsbookState.eventPageState.removeEvent(Number(key));
    };

    @action onRememberLastTab = (eventId: number): void => {
        this.appState.reduxAction.onMinimizeEvent({
            eventId: eventId,
            parameters: {},
        });

        this.appState.sportsbookState.eventPageState.addEvent(eventId);
    };

    @action onChangeEventTab = (event: string | null): void => {
        if (event === null && this.eventFromRoute !== null) {
            this.appState.routerBackoffice.closeEventPagePopup();
        }

        if (event !== null) {
            this.appState.sportsbookState.eventPageState.addToRecentlyViewed(Number(event));
        }
    };
}
